import React from 'react';
import { useTranslation } from 'react-i18next';
import './ReportsPage.css';

export function ReportsPage() {
  const { t } = useTranslation();
  return (
    <div className="reports-page">
      <div className="reports-page__container">
        <h1>{t('reports.title')}</h1>
        <p>{t('reports.oldPage.comingSoon')}</p>
      </div>
    </div>
  );
}

export default ReportsPage;
